module.exports = __webpack_public_path__ + "img/NG.508bf680.svg";